import { FieldPolicy, Reference } from '@apollo/client';

const makeEmptyData = () => {
  return { nodes: [] };
};

type KeyArgs = FieldPolicy<any>['keyArgs'];

type TInternalNodes<TNode> = Readonly<{
  nodes: TNode[];
}>;

export function offsetLimitNodesPagination<TNode = Reference>(
  keyArgs: KeyArgs = false,
): FieldPolicy<TInternalNodes<TNode>> {
  return {
    keyArgs,

    read(existing) {
      // console.log('read', existing?.nodes);
      return existing;
      // if (!existing) return;
      // const nodes = existing.nodes.filter((node) => canRead(node));
      // return {
      //   ...existing,
      //   nodes,
      // };
    },

    merge(existing = makeEmptyData(), incoming, { args }) {
      // const offset = params.variables.offset;
      // const merged = existing ? existing.slice(0) : [];

      // Insert the incoming elements in the right places, according to args.
      // const newEnd = offset + incoming.length;
      // const oldEnd = existing?.length ?? 0;
      // for (let i = Math.min(offset, oldEnd); i < newEnd; ++i) {
      //   if (i >= offset) {
      //     merged[i] = incoming[i - offset];
      //   } else if (i >= oldEnd) {
      //     // add placeholder
      //     merged[i] = null as any;
      //   }
      // }
      // return merged;

      // console.log('merge', args);
      if (!args) return existing; // TODO Maybe throw?

      // console.log('merge', incoming);

      const offset = args.offset ?? 0;
      const merged = existing ? existing.nodes.slice(0) : [];

      // Insert the incoming elements in the right places, according to args.
      const newEnd = offset + incoming.nodes.length;
      const oldEnd = existing?.nodes.length ?? 0;

      for (let i = Math.min(offset, oldEnd); i < newEnd; i += 1) {
        if (i >= offset) {
          merged[i] = incoming.nodes[i - offset];
        } else if (i >= oldEnd) {
          // add placeholder (https://github.com/apollographql/apollo-client/issues/6628)
          merged[i] = null as any;
        }
      }

      // const start = args ? args.offset : merged.length;
      // const end = start + incoming.nodes.length;
      // for (let i = start; i < end; ++i) {
      //   console.log('update', i, incoming.nodes[i - start]);
      //   merged[i] = incoming.nodes[i - start];
      // }

      // console.log('merged', merged);

      return {
        ...existing,
        ...incoming,
        nodes: merged,
      };
    },
  };
}
